import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {BaseurlService} from '../../services/baseurl.service';
import {Observable} from 'rxjs';
import {
  ArchBuildPackageBuildDto,
  ArchBuildPackageBuildStepDto,
  ArchBuildPackageCreationDto,
  ArchBuildPackageDto
} from './archbuild.models';

@Injectable({
  providedIn: 'root'
})
export class ArchbuildService {

  constructor(
    private http: HttpClient,
    private baseUrl: BaseurlService,
  ) { }

  getStatus(): Observable<ArchBuildPackageDto[]> {
    return this.http.get<ArchBuildPackageDto[]>(`${this.baseUrl.getBaseUrl()}/archbuild`);
  }

  getBuilds(pkgId: number): Observable<ArchBuildPackageBuildDto[]> {
    return this.http.get<ArchBuildPackageBuildDto[]>(`${this.baseUrl.getBaseUrl()}/archbuild/${pkgId}/builds`);
  }

  getBuildSteps(buildId: number): Observable<ArchBuildPackageBuildStepDto[]> {
    return this.http.get<ArchBuildPackageBuildStepDto[]>(`${this.baseUrl.getBaseUrl()}/archbuild/builds/${buildId}/steps`);
  }

  createNewProject(dto: ArchBuildPackageCreationDto): Observable<void> {
    return this.http.post<void>(`${this.baseUrl.getBaseUrl()}/archbuild`, dto);
  }

  manuallyBuild(pkgId: number): Observable<void> {
    return this.http.post<void>(`${this.baseUrl.getBaseUrl()}/archbuild/${pkgId}/build`, {});
  }

  ignoreFailedBuild(pkgBuildId: number): Observable<void> {
    return this.http.post<void>(`${this.baseUrl.getBaseUrl()}/archbuild/ignoreFailedBuild/${pkgBuildId}`, {});
  }
}
